<template>
    <div class="accept-container">
        <iframe id="mainIframe" ref="mainIframe" name="mainIframe"  frameborder=0 style="width:100%;height:600px;" :src="linkpage"></iframe>
    </div>
</template>

<script>
export default {
    name: 'hello',
    data () {
        return {
            linkpage:"",
            tloading:false,
        }
    },
    mounted(){
       
    },

    
    methods:{

        loadChart(data){
            let that = this;
            this.linkpage = ''
            setTimeout(function(){
                that.linkpage = 'https://032001.zhonglunnet.com/fp-web/effectScatter-bmap.html'
                const mapFrame = that.$refs['mainIframe'];
                mapFrame.onload = function() {
                    const iframeWin = mapFrame.contentWindow
                    iframeWin.postMessage(data, '*')
                }
            },500)
        },
        loadData(selectedEnv,selectedWebSys,sTimeRange){
            let queryStr = "* | select count(DISTINCT(\"__tag__:__client_ip__\")) as value,ip_to_city(\"__tag__:__client_ip__\") as name from log where project_name='" + selectedWebSys + "' group by name";
            let that = this;
            that.tloading = true;
            let sTime = sTimeRange.split('~')[0];
            let eTime = sTimeRange.split('~')[1];
            let starttime = (new Date(sTime).getTime())/1000;
            let endtime = (new Date(eTime).getTime())/1000;
            let params = {
                projectname:'fp-zl-device',
                logstorename:selectedEnv,
                starttime:starttime,
                endtime:endtime,
                sql:queryStr,
                pageSize:100,
                offset:0,
                reverse:false,
                paged:false,
                timeout:15000,
                urlparams:false
            };
            that.$store.dispatch({
                type: "logservice/querylog",
                params:params
            }).then((res)=>{
                if(res.status == 200 && res.data.success == '1'){
                    let result = res.data.data;
                    that.loadChart(result.list);

                }
                that.tloading = false;
            }).catch(() => {
                that.tloading = false;
            });
        },
   
    }
}

</script>
<style scoped>


</style>
